<div class="position-popup">
  <div class="modal-header">
    <h5 class="modal-title" id="permissionModalLabel">Positions</h5>
    <button type="button"
            *ngIf="isViewMode"
            class="btn-close"
            aria-label="Close"
            (click)="dismissPopup()"></button>
    <div class="d-flex justify-content-end ms-auto" *ngIf="!isViewMode">
      <button type="button" class="btn col-auto me-2 btn-secondary" (click)="isViewMode = true"><i class="fa fa-times"></i> Cancel</button>
      <button type="button" class="btn col-auto btn-primary" (click)="savePosition()"><i class="fa fa-save"></i> Save</button>
    </div>

  </div>
  <div class="modal-body" *ngIf="!isViewMode">
    <app-position-edit #positionEdit [(position)]="position" (positionSaved)="positionSaved($event)" (positionValidationFailed)="positionValidationFailed($event)"></app-position-edit>
  </div>
  <div class="modal-body" *ngIf="isViewMode">
    <div class="row  g-3 mt-1  justify-content-end">
      <div class="col-auto">
        <div class="custom-search-section">
          <input type="text"
                 name="somethingAutofillDoesntKnowAbout"
                 autocomplete="new-password"
                 class="form-control search-input"
                 id="search"
                 [(ngModel)]="searchTerm"
                 placeholder="Search…" />
        </div>
      </div>
      <div class="col-auto justify-content-end">
        <div class="flex justify-content-end">
          <button class="btn btn-outline-primary btn-sm ms-2"
                  type="button"
                  (click)="AddPosition()">
            <i class="fa fa-plus"></i> Add Position
          </button>
        </div>
      </div>
    </div>
    <div class="table-scroll table-responsive data-grid" #tablePosition>
      <app-position-list (editRepoPosition)="EditRepoPosition($event)" [tablePosition]="tablePosition" [(searchTerm)]="searchTerm" [(positions)]="positions"></app-position-list>
    </div>
  </div>
</div>
